import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {GpsPermissionType} from "../../types/gps-permission.type";

export class AgentGpsPermissionMultiSelectListComponent implements IController {
  gpsPermissions: string[];
  options: string[];
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(GpsPermissionType));
    }
  }

  $onChanges(changes) {
    if (changes.gpsPermissions) {
      this.selectedKeys = [];
      _.forEach(this.gpsPermissions, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  onToggle(option, isSelected) {
    this.onChange({
      gpsPermissions: isSelected ? _.concat(this.gpsPermissions, [option]) :
        _.filter(this.gpsPermissions, (status) => {
          return status !== option;
        })
    });
  }

  onReset() {
    this.onChange({gpsPermissions: []});
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentGpsPermissionMultiSelectList', {
    bindings: {
      gpsPermissions: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./agent-gps-permission-multi-select-list.html').default,
    controller: AgentGpsPermissionMultiSelectListComponent
  });


